// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2mkmd","buttons":"SendReceipts_buttons__1Uinf","email":"SendReceipts_email__3_a0B","bookApptTitle":"SendReceipts_bookApptTitle__vTC2B"};